export const alertPopupAction = (status, message, color) => {
    return {
        type: "ALERT_POPUP",
        data: {
            open: status, message, color
        }
    }
}